import { useLocation } from 'react-router-dom';

import { sectionHint, sectionLabel } from './nav';
import { TasksIndicator } from './TasksIndicator';
import { UserMenu } from './UserMenu';
import styles from './Topbar.module.css';

export function Topbar() {
  const { pathname } = useLocation();
  const label = sectionLabel(pathname);
  const hint = sectionHint(pathname);

  return (
    <header className={styles.topbar}>
      <div className={styles.brand}>
        <img className={styles.brandLogo} src="/logo.jpg" alt="" aria-hidden="true" />
        Монтаж TrafficHunters
      </div>

      <nav className={styles.crumbs} aria-label="Хлебные крошки">
        <span className={styles.crumbSep}>/</span>
        <span className={styles.crumbLabel}>{label}</span>
        {hint && <span className={styles.crumbHint}>{hint}</span>}
      </nav>

      <div className={styles.spacer} />

      <div className={styles.actions}>
        <TasksIndicator />
        <UserMenu />
      </div>
    </header>
  );
}
